import { TEAM, PHOREST_BOOKING_URL } from "@/data/content";

// Phorest direct service links (Manager › Services › Online & App › Booking Link). /book keeps the full menu (PHOREST_BOOKING_URL).
const phorestService = (id) => `https://www.phorest.com/salon/lumiereaesthetics/book/services/${id}`;
export const BOOKING_WIDGETS = {
  physician: phorestService("XoUn7Xk7csaI11nwTPYsCwOLLppf-x0DJ8PRwJyXnyc"),
  skin: phorestService("XoUn7Xk7csaI11nwTPYsC7lZzVdXFX2QQsChriQo35g"),
  hairInPerson: phorestService("XoUn7Xk7csaI11nwTPYsC6KsmCUwBzvFTHU3DbeM9Zw"),
  hairVideo: phorestService("XoUn7Xk7csaI11nwTPYsC-1gduPgZw4H1k937HQ5Tig"),
  general: PHOREST_BOOKING_URL,
};

export const AD_PATHS = ["/consult", "/skin-assessment"];

export const member = (slug) => TEAM.find((m) => m.slug === slug);

const DISCRETION =
  "Lumière sits inside an established medical centre, so arriving for a consultation looks exactly like arriving for a GP appointment.";

export const AD_PAGES = {
  consult: {
    path: "/consult",
    serviceKey: "physician",
    title: "Start with a consultation | Lumière Aesthetics, Cottesloe",
    description: "Not sure whether you need a treatment? A 45-minute consultation with a physician in Cottesloe — examination, history, written plan. $250, redeemable against treatment.",
    eyebrow: "Cottesloe · Doctor-run aesthetics",
    h1: "Not sure whether you need a treatment? Start with a consultation.",
    standfirst: "Forty-five minutes with a physician. An examination, a proper history, a written plan — and sometimes the advice to wait.",
    practitioners: ["dr-kristy-truong", "dr-anthony-chaffee", "dr-kiran-shahid"],
    practitionerNote: "Not sure who to see? Choose \u201cAny physician\u201d and we\u2019ll match you.",
    offer: ["$250", "45 minutes", "Redeemable against treatment within 30 days"],
    proof: ["Doctor-run", "A physician assesses you first", "Inside a medical centre, discreet by design"],
    widget: "physician",
    widgetHeading: "Choose a time with a physician",
    hero: { src: "/images/treatment-room.webp", alt: "A white treatment chair beside a sheer curtain and an orchid in the Lumière consulting room", label: "The consulting room" },
    steps: [
      "You tell us what you\u2019ve noticed",
      "A physician examines and takes a proper history",
      "You get an honest opinion and a written plan",
      "You decide \u2014 nothing is booked on the day",
    ],
    credentials: [
      "Dr Kristy Truong \u2014 The Procedural Physician \u00b7 US fellowship-trained in facial plastic and reconstructive surgery \u00b7 AHPRA MED0002351485",
      "Dr Anthony Chaffee \u2014 The Longevity Physician \u00b7 Medical Director, Elevate Medical Clinics \u00b7 AHPRA MED0002263360",
      "Dr Kiran Shahid \u2014 The Skin Physician \u00b7 MBBS, FRACGP \u00b7 Practising in Perth since 1991 \u00b7 AHPRA MED0001577305",
    ],
    discretion: DISCRETION,
  },
  skin: {
    path: "/skin-assessment",
    serviceKey: "skin",
    title: "Skin assessment with Dr Kiran Shahid | Lumière Aesthetics, Cottesloe",
    description: "Pigmentation, redness and skin \u2014 diagnosed before it\u2019s treated. A 45-minute assessment with Dr Kiran Shahid in Cottesloe. $250, redeemable against treatment.",
    eyebrow: "Skin · Dr Kiran Shahid",
    h1: "Pigmentation, redness and skin \u2014 diagnosed before it\u2019s treated.",
    standfirst: "Sun damage, melasma, post-inflammatory pigment, rosacea and flushing all look alike and need different treatment. A 45-minute assessment tells you which you have.",
    practitioners: ["dr-kiran-shahid"],
    credentialLine: "Dermatology-trained \u00b7 MBBS, FRACGP, Fellow of the Australian Institute of Dermatology \u00b7 Practising in Perth since 1991",
    offer: ["$250", "45 minutes", "Examination, dermatoscopic check where warranted, diagnosis and a written plan", "Redeemable against treatment"],
    proof: ["Doctor-run", "Examined before treated", "Inside a medical centre, discreet by design"],
    widget: "skin",
    widgetHeading: "Choose a time with Dr Shahid",
    hero: { src: "/images/scenes/skin-assessment.webp", alt: "A doctor examining the skin of the cheek with a dermatoscope in a warm consulting room, an orchid behind", label: "The skin assessment" },
    steps: [
      "Examination, including dermatoscopy where a spot warrants it",
      "A diagnosis \u2014 sun damage, melasma, vascular or something that needs a closer look",
      "A written skin plan",
      "Treatment only where it\u2019s the right answer",
    ],
    stepsNote: "If Dr Shahid finds something that needs medical follow-up, she will say so \u2014 the assessment is a medical examination first.",
    credentials: [
      "Dr Kiran Shahid \u2014 The Skin Physician \u00b7 MBBS, FRACGP, Fellow of the Australian Institute of Dermatology \u00b7 Practising in Perth since 1991 \u00b7 AHPRA MED0001577305",
    ],
    discretion: DISCRETION,
  },
};
